import { render, staticRenderFns } from "./BaseEChart.vue?vue&type=template&id=54e38340&scoped=true"
import script from "./BaseEChart.vue?vue&type=script&lang=js"
export * from "./BaseEChart.vue?vue&type=script&lang=js"
import style0 from "./BaseEChart.vue?vue&type=style&index=0&id=54e38340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e38340",
  null
  
)

export default component.exports